// extracted by mini-css-extract-plugin
export var infoRow = "_p5-2";
export var labelContainer = "_p5-0";
export var rightInfo = "_p5-1";